module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-4.16a01f14.svg";